import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LogService } from '../../common/log.service';
import { MiscFunctionsService } from '../../common/misc-functions.service';

export class HttpTranslateLoader implements TranslateLoader {
    private logService = new LogService(this.httpClient, new MiscFunctionsService());

    constructor(private httpClient: HttpClient) {
    }
  
   public getTranslation=(lang: string): Observable<File> => {
      const defaultFile = `/assets/i18n/${lang}.json`;
      const fallback = `/assets/i18n/en-US.json`;
  
      this.logService.logInfo(`device-authentication: http-translate-loader - defaultFile = ${defaultFile}`);

      return this.httpClient.get<File>(defaultFile).pipe(
        map((result): File => {
          return result;
        }),
        catchError((): Observable<File> => {
          this.logService.logWarning(`device-authentication: http-translate-loader - ${defaultFile} does not exists. Falling back to en-US.json.`);

          return this.httpClient.get<File>(this.normalizedLanguage(defaultFile)).pipe(
            map((result): File => {
              return result;
            }),
            catchError((): Observable<File> => {
              this.logService.logWarning(`device-authentication: http-translate-loader - ${defaultFile} does not exists. Falling back to en-US.json.`);
    
              return this.httpClient.get<File>(fallback);
            })
          );
        })
      );
    }

    private normalizedLanguage=(language:string) =>{
      return `${language.split("-")[0]}.json`;
    }
  }
  